export function PageHeader({ icon: Icon, eyebrow, title, subtitle, children }) {
  return (
    <div data-testid="page-header" className="flex flex-col items-center justify-center text-center mx-auto max-w-2xl px-4 pt-1 pb-5 sm:pb-6 space-y-2.5">
      {eyebrow && (
        <span className="inline-flex items-center justify-center gap-1.5 font-mono text-xs font-semibold tracking-widest uppercase bg-copper/12 text-copper px-3.5 py-1 rounded-full border border-copper/20">
          {Icon && <Icon className="w-3.5 h-3.5" />} {eyebrow}
        </span>
      )}
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-bronze leading-tight tracking-tight">{title}</h1>
      <div className="w-20 sm:w-28 h-1 bg-gradient-to-r from-copper via-penny to-sage rounded-full opacity-90" />
      {subtitle && <p className="text-sm sm:text-base text-foreground/75 max-w-xl leading-relaxed">{subtitle}</p>}
      {children}
    </div>
  );
}

export default PageHeader;
